<template>
  <section class="collection-page contacts-page">
    <header class="collection-header">
      <div><span class="eyebrow">Base de relacionamento</span><h2>Contatos</h2><p>Organize sua audiência, listas, tags e dados personalizados.</p></div>
      <router-link
        :to="{
          name: 'ContactNew',
          params: {},
        }"
      >
        <div class="button primary"><i class="fas fa-user-plus"></i> Novo contato</div>
      </router-link>
    </header>

    <div class="contact-tools">
      <button class="tool-button" type="button" @click="showModalList = true"><i class="fas fa-list"></i><span>Listas</span></button>
      <button class="tool-button" type="button" @click="showModalTag = true"><i class="fas fa-tag"></i><span>Tags</span></button>
      <button class="tool-button" type="button" @click="showModalCustomField = true"><i class="fas fa-sliders-h"></i><span>Campos personalizados</span></button>
      <button class="tool-button" type="button" @click="showModalImport = true"><i class="fas fa-file-import"></i><span>Importar contatos</span></button>
    </div>

    <!-- filters -->
    <div class="filters-card">
      <div class="flex-1">
        <div class="flex filters-group-holder row middle">
          <div class="filter-item">
            <label>Lista</label>
            <select class="input" v-model="filters.data.list">
              <option
                v-for="(c, index) in filters.list.list"
                :key="index"
                :value="c.value"
                :selected="c.value === filters.data.list"
              >
                {{ c.label }}
              </option>
            </select>
          </div>
          <div class="filter-item">
            <label>Tag</label>
            <select class="input" v-model="filters.data.tag">
              <option
                v-for="(c, index) in filters.list.tag"
                :key="index"
                :value="c.value"
                :selected="c.value === filters.data.tag"
              >
                {{ c.label }}
              </option>
            </select>
          </div>

          <button type="button" class="clear-filters" title="Limpar filtros" @click="filters.data.tag = ''; filters.data.list = ''"><i class="fas fa-times"></i> Limpar</button>
        </div>
      </div>
      <div class="flex-1">
        <div class="flex w100 end filters-groupo-holder middle margin-top-l">
          <div class="contact-search">
            <i class="fas fa-search"></i>
            <input
              class="input"
              v-model="filters.data.search"
              type="text"
              placeholder="Buscar por nome ou e-mail"
              @keyup.enter="searchContacts()"
            />
          </div>
          <button type="button" class="button primary search-button" @click="searchContacts()">Buscar</button>
        </div>
      </div>
    </div>

    <div class="collection-toolbar contacts-toolbar">
      <div class="flex-1">
        <div class="result-count">
          <span v-if="!loading">{{ totalContact | number }}</span>
          <span v-else>—</span>
          contatos encontrados
        </div>
      </div>
      <div class="flex-1">
        <div class="flex end">
          <div class="flex between middle">
            <paginate
              :containerClass="'pagination'"
              :page-count="totalPages"
              v-model="page"
              :page-range="5"
              :click-handler="clickCallback"
              :prev-text="'Anterior'"
              :next-text="'Próxima'"
            ></paginate>
          </div>
        </div>
      </div>
    </div>

    <div class="flex-1 w100 margin-to-l">
      <ul>
        <li v-for="(contact, index) in contacts" :key="index">
          <div class="box margin-top-m">
            <div class="box-content">
              <div class="flex middle row">
                <div class="flex-3">
                  <div class="flex middle row">
                    <div class="flex-1 name margin-top-s">
                      <p>{{ contact.first_name }} {{ contact.last_name }}</p>
                      <div class="flex column">
                        <div>
                          <small>{{ contact.email }}</small>
                        </div>
                        <div>
                          <small>{{ contact.phone }}</small>
                        </div>
                      </div>
                    </div>
                    <div class="flex-2 margin-top-s">
                      <div class="flex details between">
                        <!-- <div>
                          <p>Origem</p>
                          <small>{{ contact.source }}</small>
                        </div> -->
                        <div>
                          <p>Listas</p>
                          <div class="tags">
                            <span v-for="(v, k) in contact.lists" :key="k">{{
                              v.name
                            }}</span>
                          </div>
                        </div>
                        <div>
                          <p>Tags</p>
                          <div class="tags">
                            <span v-for="(v, k) in contact.tags" :key="k">{{
                              v.name
                            }}</span>
                          </div>
                        </div>
                        <div>
                          <p>Criação:</p>
                          <small>
                            {{ contact.created_at_external | date }}</small
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="action">
                  <div class="flex end">
                    <router-link
                      v-if="false"
                      :to="{
                        name: 'ContactDetail',
                        params: { contact_id: contact.id },
                      }"
                    >
                      <div class="button primary">Detalhes</div>
                    </router-link>

                    <router-link
                      style="margin-left: 8px"
                      :to="{
                        name: 'ContactEdit',
                        params: { contact_id: contact.id },
                      }"
                    >
                      <div class="button secondary">Editar</div>
                    </router-link>
                    <a
                      @click="openModalDelete(contact.id)"
                      style="margin-left: 8px"
                    >
                      <div class="button secondary">Deletar</div>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </li>
      </ul>
      <div v-if="isEmpty" class="box center-text margin-top-l">
        <div class="box-content">
          <p>
            Não encontramos nenhum contato. Assim que você tiver a primeira
            venda os contatos vão automaticamente aparecer na lista.
          </p>
        </div>
      </div>

      <div v-if="loading">
        <content-loading>
          <fake-line height="30"></fake-line>
          <fake-line height="30"></fake-line>
          <fake-line height="30"></fake-line>
          <fake-line height="30"></fake-line>
        </content-loading>
      </div>

      <!-- pagination -->
      <div class="flex-1 flex row w100 middle">
        <div class="flex w100 end filters-groupo-holder">
          <div class="flex between middle">
            <paginate
              :containerClass="'pagination'"
              :page-count="totalPages"
              v-model="page"
              :page-range="5"
              :click-handler="clickCallback"
              :prev-text="'Anterior'"
              :next-text="'Próxima'"
            ></paginate>
          </div>
        </div>
      </div>
    </div>

    <!-- modals -->
    <!-- tags -->
    <tags
      :show="showModalTag"
      @close="
        showModalTag = false;
        selectTag = null;
      "
      @accept="newOrEditTag($event)"
    ></tags>
    <!-- lists -->
    <lists
      :show="showModalList"
      @close="
        showModalList = false;
        selectTag = null;
      "
      @accept="newOrEditTag($event)"
    ></lists>

    <!-- custom fields -->
    <custom-fields
      :show="showModalCustomField"
      @close="
        showModalCustomField = false;
        selectTag = null;
      "
      @accept="newOrEditTag($event)"
    ></custom-fields>

    <!-- imports -->
    <imports
      :show="showModalImport"
      @close="
        showModalImport = false;
        selectImport = null;
      "
      @accept="newOrEditTag($event)"
    ></imports>


    <!-- modal confirm delete -->
    <modal-confirm
      :show="showDeleteModal"
      description="Você tem certeza que deseja deletar esse contato?"
      @cancel="
        showDeleteModal = false;
        selectModalDelete = null;
      "
      @accept="removeContact(selectModalDelete)"
    ></modal-confirm>
  </section>
</template>

<script>
import moment from "moment";
moment.locale("pt-br");

import { getContacts, removeContact } from "@/services/contact";

import { getTags } from "@/services/tag";
import { getLists } from "@/services/list";

import Tags from "./Tags";
import CustomFields from "./CustomFields.vue";
import Lists from "./Lists.vue";

import Imports from "./Imports.vue";

import ModalConfirm from "@/components/modal/ModalConfirm";

export default {
  name: "contact",
  components: {
    Tags,
    CustomFields,
    Lists,
    Imports,
    ModalConfirm,
  },
  data() {
    return {
      loading: false,
      showDeleteModal: false,
      selectModalDelete: null,
      filters: {
        data: {
          search: "",
          list: "",
          tag: "",
        },
        list: {
          list: [],
          tag: [],
        },
      },
      contacts: [],
      totalContact: 0,
      offset: 100,
      page: 1,

      //
      showModalTag: false,
      showModalList: false,
      showModalCustomField: false,
      //
      selectTag: null,
      selectList: null,
      selectCustomField: null,
      //
      showModalImport: false,
    };
  },
  mounted() {
    this.getContacts();

    this.getTags();
    this.getLists();
  },
  computed: {
    isEmpty() {
      // return !this.loading && this.products && this.products.length === 0;
      return this.totalContact === 0 && !this.loading;
    },
    totalPages() {
      let valueMode = this.totalContact % this.offset;
      let value = this.totalContact / this.offset;

      let pages = 1;

      if (valueMode == 0) {
        pages = value;
      } else {
        pages = parseInt(value) + 1;
      }

      return pages;
    },
  },
  watch: {
    page: {
      handler() {
        this.contacts = [];
        this.getContacts();
      },
    },
    "filters.data.tag": {
      handler() {
        this.contacts = [];
        this.getContacts();
      },
    },
    "filters.data.list": {
      handler() {
        this.contacts = [];
        this.getContacts();
      },
    },
  },
  methods: {
    newOrEditTag(event) {
      console.log('event', event)
    },
    openModalDelete(contactId) {
      this.showDeleteModal = true;
      this.selectModalDelete = contactId;
    },
    searchContacts() {
      this.contacts = [];
      this.page = 1;
      this.getContacts();
    },
    getTags() {
      getTags()
        .then((result) => {
          this.filters.list.tag = result.map((r) => {
            return { value: r.id, label: r.name };
          });
          this.filters.list.tag.unshift({
            value: "",
            label: " ------ ",
          });
          this.filters.list.tag.unshift({
            value: "",
            label: " Selecione uma tag ",
          });
        })
        .catch(() => {
          this.$toast.error({
            title: "Erro",
            message: "falha ao buscar tags",
          });
        });
    },
    getLists() {
      getLists()
        .then((result) => {
          this.filters.list.list = result.map((r) => {
            return { value: r.id, label: r.name };
          });

          this.filters.list.list.unshift({
            value: "",
            label: " ------ ",
          });
          this.filters.list.list.unshift({
            value: "",
            label: " Selecione uma Lista ",
          });
        })
        .catch(() => {
          this.$toast.error({
            title: "Erro",
            message: "falha ao buscar listas",
          });
        });
    },
    removeContact(contactId) {
      this.showDeleteModal = false;
      this.selectModalDelete = null;

      removeContact(contactId)
        .then(() => {
          this.contacts = this.contacts.filter((c) => c.id != contactId);

          this.$toast.success({
            title: "Sucesso",
            message: "Contato removido com sucesso",
          });
        })
        .catch(() => {
          this.$toast.error({
            title: "Erro",
            message: "Falha ao remover contato",
          });
        });
    },
    getContacts() {
      this.loading = true;
      let params = {
        page: this.page,
        offset: this.offset,
        search: this.filters.data.search,
        tag: this.filters.data.tag,
        list: this.filters.data.list,
      };
      getContacts(params)
        .then((result) => {
          this.contacts = result.contacts;
          this.totalContact = result.total;
        })
        .catch(() => {
          this.$toast.error({
            title: "Erro",
            message: "Ocorreu um problema ao buscar contatos",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../collection-page";

.contact-tools { margin-bottom: 18px; display: flex; gap: 8px; flex-wrap: wrap; }
.tool-button { min-height: 40px; padding: 9px 13px; display: inline-flex; align-items: center; gap: 8px; border: 1px solid #e4e7ec; border-radius: 9px; color: #475467; background: #fff; font-weight: 650; cursor: pointer; }
.tool-button i { color: #7c3aed; }
.tool-button:hover { border-color: #cfc4e4; color: #6d28d9; background: #faf8ff; }
.filters-card { margin-bottom: 16px; padding: 18px; display: flex; align-items: flex-end; justify-content: space-between; gap: 20px; border: 1px solid #e7e9f0; border-radius: 14px; background: #fff; }
.filters-card .filter-item label { margin-bottom: 7px; color: #667085; font-size: 1.1rem; font-weight: 650; }
.filters-card select.input { min-width: 170px; height: 42px; margin: 0; border: 1px solid #d9dce5; border-radius: 9px; }
.clear-filters { min-height: 40px; margin-top: 18px; padding: 8px 11px; border: 0; color: #667085; background: transparent; cursor: pointer; }
.clear-filters:hover { color: #6d28d9; }
.contact-search { position: relative; width: 100%; max-width: 330px; }
.contact-search > i { position: absolute; left: 14px; top: 50%; z-index: 1; color: #98a2b3; transform: translateY(-50%); }
.contact-search input.input { height: 42px; margin: 0; padding-left: 38px; border: 1px solid #d9dce5; border-radius: 9px; }
.search-button { min-height: 42px; margin-left: 7px; }
.contacts-toolbar { padding-left: 18px; }
.contacts-toolbar .pagination { margin: 0; }
.contacts-page > div:nth-of-type(4) > ul { list-style: none; }
.contacts-page > div:nth-of-type(4) > ul > li > .box { margin-top: 12px; border-radius: 14px; }
.contacts-page .name p { color: #171923; font-size: 1.5rem; font-weight: 700; }
.contacts-page .name small { margin-top: 4px; display: block; color: #667085; font-weight: 500; }
.details > div { margin-right: 26px; }
.details p { margin-bottom: 6px; color: #98a2b3; font-size: 1rem; font-weight: 650; text-transform: uppercase; }
.details small { color: #344054; font-weight: 650; }
.tags span { margin: 2px 4px 2px 0; padding: 4px 8px; display: inline-block; border: 1px solid #e3d8fa; border-radius: 99px; color: #6d28d9; background: #f6f1ff; font-size: .9rem; font-weight: 650; }
.contacts-page .action .button { min-height: 38px; padding: 10px 13px; }

@media screen and (max-width: 1024px) {
  .filters-card { align-items: stretch; flex-direction: column; }
  .filters-card > .flex-1, .filters-card .contact-search { width: 100%; }
  .filters-card .filters-group-holder { justify-content: flex-start; }
  .contacts-page .box-content > .flex, .contacts-page .box-content .flex.row { align-items: stretch; }
  .details { margin-top: 14px; flex-direction: row !important; }
  .action { margin-top: 16px; }
}
@media screen and (max-width: 640px) {
  .contact-tools { display: grid; grid-template-columns: 1fr 1fr; }
  .filters-card .filters-group-holder { flex-direction: column !important; align-items: stretch; }
  .filter-item { margin: 0 0 10px; }
  .filters-card select.input { width: 100%; }
  .clear-filters { margin-top: 0; }
  .details { display: grid; grid-template-columns: 1fr 1fr; gap: 14px; }
  .details > div { margin: 0; }
}
</style>
